
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { Row, Heading, LoaderIndicator } from '@warrenbrasil/nebraska-web';
import { ITransactionSummary } from '@/types/models';
import { TransactionBadge } from '@/modules/common/components/TransactionBadge';
import { TransactionModal } from '@/modules/transaction/components/TransactionModal';
import {
  hasDetails,
  getTransactionType
} from '@/modules/transaction/helpers/transaction';
import { useDashStore } from '@/modules/common/store/DashModule';

@Component({
  components: {
    TransactionModal,
    TransactionBadge,
    Heading,
    Row,
    LoaderIndicator
  }
})
export default class TransactionsSummaryList extends Vue {
  private readonly dashModule = useDashStore();
  private getTransactionType = getTransactionType;
  private transactionId?: string | null = '';
  private transactionType?: string | null = '';
  private showModal = false;
  private date = '-';

  @Prop({ type: Array, required: true })
  private transactions!: ITransactionSummary[];

  @Prop({ type: String, required: true })
  private module!: string;

  @Prop({ type: String, required: false })
  private path!: string;

  @Prop({ type: String, required: true })
  private title!: string;

  @Prop({ type: Boolean })
  private isTransactionLoading!: boolean;

  @Emit('on-transaction-click')
  emitTransactionClick(transaction: ITransactionSummary) {
    return transaction;
  }

  @Emit('on-redirect-to-transactions')
  emitSeeMoreClick() {}

  private get backTo() {
    if (this.path) return `${this.module}/${this.path}`;
    else return this.module;
  }

  private get shouldShowMoney() {
    return this.dashModule.showMoney;
  }

  private handleClick(event: Event) {
    event.preventDefault();
    this.emitSeeMoreClick();

    this.$router.push({
      name: 'transactions',
      query: {
        module: this.module,
        backTo: this.backTo
      }
    });
  }

  private transactionHasDetails(transaction: ITransactionSummary) {
    return (
      transaction.type &&
      hasDetails(transaction.type!.value!, transaction.status!.value!)
    );
  }

  private onSelectTransaction(transaction: ITransactionSummary) {
    if (this.transactionHasDetails(transaction)) {
      this.transactionId = transaction.id;
      this.transactionType =
        transaction.typeV2?.value || transaction.type?.value;
      this.emitTransactionClick(transaction);
      this.showModal = true;
    }
  }

  private removeTransaction(id: string) {
    this.transactions = this.transactions.filter(transaction => {
      const transactionId = transaction.id;
      return transactionId !== id;
    });
  }

  private closeModal(transactionId: string) {
    if (transactionId) this.removeTransaction(transactionId);

    this.transactionId = '';
    this.transactionType = '';
    this.showModal = false;
  }

  private emitCancelTransaction() {
    this.$emit('cancel-transaction');
  }
}
